import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const appwrite = defineConnector({
  identifier: "appwrite",
  name: "Appwrite",
  tagLine: "Backend as a service platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) =>
    headerAuth([
      { name: "X-Appwrite-Key", value: app.secret.apiKey },
      {
        name: "X-Appwrite-Project",
        value: app.config.projectId,
      },
    ]),
  steps: [
    {
      title: "Get your Appwrite API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Appwrite Console](https://cloud.appwrite.io/), go to your project, then **Settings > API Keys** and create a new API key with the scopes you need.",
        },
      ],
    },
    {
      title: "Enter your Appwrite details",
      items: [
        {
          kind: "baseUrl",
          label: "Appwrite endpoint",
          required: true,
          placeholder: "https://cloud.appwrite.io/v1",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The API endpoint of your Appwrite instance.",
        },
        {
          kind: "input",
          label: "Project ID",
          required: true,
          target: { kind: "configuration", field: "projectId" },
          helperText: "Your Appwrite project ID.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/health`,
  },
});
